import { useCabinetText } from "../../content/CabinetContentContext";
import { useEffect, useRef, useState } from "react";
import {
  MAX_CHAT_MESSAGE_LENGTH,
  markRead,
  sendMessage,
  subscribeMessages,
} from "../../chat/chatService";
import { auth } from "../../firebase";
import CloseButton from "../common/CloseButton";
export default function UserChat({ uid, userProfile, onClose }) {
  const t = useCabinetText("chat");
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const listRef = useRef(null);
  const lastReadMessageRef = useRef(null);
  // Закривати по Escape
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);
  useEffect(() => {
    if (!uid) return;
    const unsub = subscribeMessages(uid, (list) => {
      setMsgs(list);
      const last = list[list.length - 1];
      if (
        last?.from === "admin" &&
        last.id !== lastReadMessageRef.current
      ) {
        lastReadMessageRef.current = last.id;
        markRead(uid, "user").catch((readError) => {
          console.error("[UserChat] Не вдалося позначити повідомлення:", readError);
        });
      }
      setTimeout(() => {
        listRef.current?.scrollTo({
          top: listRef.current.scrollHeight,
          behavior: "smooth",
        });
      }, 0);
    }, (subscriptionError) => {
      console.error("[UserChat] Помилка підписки:", subscriptionError);
      setError("Не вдалося завантажити повідомлення.");
    });
    // позначити прочитаним для користувача
    markRead(uid, "user").catch((readError) => {
      console.error("[UserChat] Не вдалося позначити чат прочитаним:", readError);
    });
    return () => unsub && unsub();
  }, [uid]);

  const onSend = async () => {
    if (!text.trim() || sending) return;

    setSending(true);
    setError("");
    try {
      await sendMessage(uid, {
        text,
        from: "user",
        senderId: auth?.currentUser?.uid || uid,
        userProfile,
      });
      setText("");
    } catch (sendError) {
      console.error("[UserChat] Помилка надсилання:", sendError);
      setError("Повідомлення не надіслано. Спробуйте ще раз.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        right: 16,
        bottom: 16,
        width: "min(360px, calc(100vw - 32px))",
        maxWidth: "calc(100vw - 32px)",
        boxSizing: "border-box",
        maxHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #ddd",
        borderRadius: 12,
        background: "#fff",
        boxShadow: "0 10px 30px rgba(0,0,0,.15)",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          padding: "10px 12px",
          borderBottom: "1px solid #eee",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ fontWeight: 700 }}>{t("text001")}</div>
        <CloseButton onClick={onClose} />
      </div>

      {error && (
        <div role="alert" style={{ padding: "8px 12px", color: "#b91c1c" }}>
          {error}
        </div>
      )}

      <div
        ref={listRef}
        style={{
          flex: 1,
          overflow: "auto",
          padding: 12,
          background: "#fafafa",
        }}
      >
        {msgs.map((m) => (
          <div
            key={m.id}
            style={{
              display: "flex",
              justifyContent: m.from === "user" ? "flex-end" : "flex-start",
              marginBottom: 8,
            }}
          >
            <div
              style={{
                maxWidth: "70%",
                padding: "8px 12px",
                borderRadius: 12,
                background: m.from === "user" ? "#3e51c1" : "#fff",
                color: m.from === "user" ? "#fff" : "#000",
                border:
                  m.from === "user" ? "1px solid #3e51c1" : "1px solid #eee",
              }}
            >
              {m.text}
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          padding: 10,
          borderTop: "1px solid #eee",
          width: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          gap: 8,
          overflow: "hidden",
        }}
      >
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={t("text002")}
          maxLength={MAX_CHAT_MESSAGE_LENGTH}
          onKeyDown={(e) => {
            if (e.key === "Enter" && text.trim() && !sending) onSend();
          }}
          style={{
            flex: "1 1 0",
            width: 0,
            minWidth: 0,
            border: "1px solid #ddd",
            borderRadius: 10,
            padding: "10px 12px",
            boxSizing: "border-box",
          }}
        />
        <button
          onClick={onSend}
          disabled={!text.trim() || sending}
          style={{
            flex: "0 0 auto",
            maxWidth: "45%",
            whiteSpace: "nowrap",
            background: "#3e51c1",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "10px 14px",
            cursor: "pointer",
            boxSizing: "border-box",
          }}
        >{sending ? "Надсилання..." : t("text003")}</button>
      </div>
    </div>
  );
}
